import { createContext, useContext, useState, useEffect, useCallback } from 'react';

const RfqContext = createContext(null);
const KEY = 'axicor_rfq_items';

export const useRfq = () => useContext(RfqContext);

export function RfqProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((item) => {
    setItems(prev => {
      if (prev.some(p => p.name === item.name && p.form === (item.form || ''))) return prev;
      return [...prev, { name: item.name, grade_slug: item.grade_slug || '', form: item.form || '',
                         size: item.size || '', quantity: '', notes: '' }];
    });
    setOpen(true);
  }, []);

  const updateItem = useCallback((index, patch) => {
    setItems(prev => prev.map((it, i) => (i === index ? { ...it, ...patch } : it)));
  }, []);

  const removeItem = useCallback((index) => {
    setItems(prev => prev.filter((_, i) => i !== index));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  return (
    <RfqContext.Provider value={{ items, addItem, updateItem, removeItem, clear, open, setOpen }}>
      {children}
    </RfqContext.Provider>
  );
}
